import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fieldWrapper field" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "label"
}
const _hoisted_4 = { class: "control" }
const _hoisted_5 = ["value", "disabled", "placeholder"]

import { ref, PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormNumberField',
  props: {
    modelValue: null,
    label: null,
    validator: null,
    validationId: null,
    placeholder: null,
    isDisabled: { type: Boolean },
    isPassword: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue?: number,
  label?: string,
  validator?: (fieldId: any, val: any) => boolean,
  validationId?: string,
  placeholder?: string,
  isDisabled?: boolean,
  isPassword?: boolean,
}



// The input element where the form field's value will be bound
const inputElem = ref<any>(null);

// Event for two-way binding

const onInput = () => {
  emit('update:modelValue', parseFloat(inputElem.value.value));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "top")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("input", {
        ref_key: "inputElem",
        ref: inputElem,
        class: _normalizeClass(["input", { 'is-danger': __props.validator ? !__props.validator(__props.validationId ? __props.validationId : this, __props.modelValue) : false }]),
        type: "number",
        value: __props.modelValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (onInput())),
        disabled: __props.isDisabled,
        placeholder: __props.placeholder
      }, null, 42, _hoisted_5),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})